//@flow
import * as React from 'react';
import LocationCard from 'common/components/core/card/LocationCard';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import LocationGeocodeEditSelectors from 'common/redux/selectors/locationGeocodeEdit';
import { withRouter } from 'common/components/core/router';
import NumberUtils from 'common/utils/NumberUtils';
import DataUtils from 'common/utils/DataUtils';
import { GeocodeEditLocation } from 'common/models/internal/GeocodeEditLocation';

const mapStateToProps = (state, props) => {
    const isValidateInProgress = LocationGeocodeEditSelectors.getIsValidatingLocation(
        state,
        props
    );
    const isEditInProgress = LocationGeocodeEditSelectors.getIsEditingLocation(
        state,
        props
    );
    const isVerifyInProgress = LocationGeocodeEditSelectors.getIsVerifyingLocation(
        state,
        props
    );
    return {
        isEditInProgress,
        isVerifyInProgress,
        isValidateInProgress
    };
};

type Props = {
    locationEntity: GeocodeEditLocation
};

class BulkLocationCardContainer extends React.PureComponent<Props> {
    render() {
        const { locationEntity, ...others } = this.props;
        const {
            name,
            code,
            address,
            geometry,
            originalGeometry,
            isOriginal,
            id,
            geocodeVerifiedGeometry
        } = locationEntity;
        const { latLng, confidence: currentConfidence } = geometry || {};
        let lat;
        let lng;
        if (latLng) {
            lat = NumberUtils.round(latLng.lat, 2);
            lng = NumberUtils.round(latLng.lng, 2);
        }
        const latLngText =
            !DataUtils.isEmpty(lat) && !DataUtils.isEmpty(lng)
                ? `${lat}, ${lng}`
                : null;
        let originalConfidence;
        if (!isOriginal) {
            originalConfidence = originalGeometry
                ? originalGeometry.getIn(['confidence'], 'LOW')
                : 'LOW';
        }

        return (
            <LocationCard
                {...others}
                locationEntity={locationEntity}
                latLngText={latLngText}
                latLngIcon={geometry?.getProviderIcon()}
                id={id}
                label={name}
                subText={code || id}
                address={address?.getFilteredFullAddress() || ''}
                originalConfidence={originalConfidence}
                currentConfidence={currentConfidence}
                geocodeVerifiedGeometry={geocodeVerifiedGeometry}
            />
        );
    }
}
export default compose(
    withRouter,
    connect(mapStateToProps)
)(BulkLocationCardContainer);
